let context: AudioContext;
const Context = window.AudioContext || window.webkitAudioContext;

// https://www.mattmontag.com/web/unlock-web-audio-in-safari-for-ios-and-macos
function unlockAudioContext(ctx: AudioContext) {
  if (ctx.state !== 'suspended') return;
  const b = document.body;
  const events = [
    'touchstart',
    'touchend',
    'mousedown',
    'keydown',
    'pointerdown',
  ];

  const clean = () => {
    events.forEach((e) => b.removeEventListener(e, unlock, true));
  };

  const unlock = () => {
    ctx.resume().then(clean);
  };

  events.forEach((e) => b.addEventListener(e, unlock, true));
}

export function getContext() {
  if (!context) {
    context = new Context();
    unlockAudioContext(context);
  }

  return context;
}
